/**
 * mm-payback-calculator.js
 * Manual measure vs handheld scan. All hours and rates come from the form.
 * Idempotent: each [data-mm-payback] root inits once.
 */
(function () {
  var KEYS = [
    'jobs_month',
    'rate',
    'area',
    'manual_site',
    'manual_people',
    'manual_draft',
    'manual_return_pct',
    'manual_return_hours',
    'scan_site',
    'scan_process',
    'scan_model',
    'scan_return_pct'
  ];

  var SCANNER_PRICES = {
    c1: 6199,
    'c1-pro': 7999
  };

  var URL_PREFIX = 'pb_';

  function num(el) {
    if (!el) return 0;
    var n = parseFloat(String(el.value).replace(/,/g, ''));
    return Number.isFinite(n) ? n : 0;
  }

  function clamp(n, min) {
    if (!Number.isFinite(n)) return min || 0;
    if (min != null && n < min) return min;
    return n;
  }

  function round(n, d) {
    var f = Math.pow(10, d == null ? 1 : d);
    return Math.round(n * f) / f;
  }

  function money(n) {
    var abs = Math.abs(n);
    var formatted = abs.toLocaleString('en-AU', {
      maximumFractionDigits: 0
    });
    return (n < 0 ? '-$' : '$') + formatted;
  }

  function hoursLabel(n) {
    var v = round(n, 1);
    if (Object.is(v, -0)) v = 0;
    return v.toLocaleString('en-AU', { maximumFractionDigits: 1 }) + ' h';
  }

  function jobWord(n) {
    return Math.abs(n - 1) < 0.05 ? 'job' : 'jobs';
  }

  function jobsLabel(n) {
    return round(n, 1).toLocaleString('en-AU', { maximumFractionDigits: 1 });
  }

  function jobsPhrase(n) {
    return jobsLabel(n) + ' ' + jobWord(n);
  }

  function readScanner(root) {
    var sel = root.querySelector('[data-pb="scanner"]');
    var out = {
      scanner: 'c1-pro',
      scanner_cost: SCANNER_PRICES['c1-pro'],
      scanner_name: 'SHARE C1 Pro'
    };
    if (!sel) return out;
    var value = sel.value === 'c1' ? 'c1' : 'c1-pro';
    var opt = sel.options[sel.selectedIndex];
    var price = opt && parseFloat(opt.getAttribute('data-price'));
    out.scanner = value;
    out.scanner_cost = Number.isFinite(price) ? price : SCANNER_PRICES[value];
    out.scanner_name = (opt && opt.getAttribute('data-name')) || (value === 'c1' ? 'SHARE C1' : 'SHARE C1 Pro');
    return out;
  }

  function readInputs(root) {
    var o = {};
    KEYS.forEach(function (k) {
      o[k] = num(root.querySelector('[data-pb="' + k + '"]'));
    });
    o.manual_people = clamp(o.manual_people, 1);
    o.jobs_month = clamp(o.jobs_month, 0);
    o.software_year = 0;
    var kit = readScanner(root);
    o.scanner = kit.scanner;
    o.scanner_cost = kit.scanner_cost;
    o.scanner_name = kit.scanner_name;
    return o;
  }

  function compute(d) {
    var manHours =
      d.manual_site * d.manual_people +
      d.manual_draft +
      (d.manual_return_pct / 100) * d.manual_return_hours;
    var scanHours =
      d.scan_site +
      d.scan_process +
      d.scan_model +
      (d.scan_return_pct / 100) * d.manual_return_hours;
    var saved = manHours - scanHours;
    var valueJob = saved * d.rate;
    var jobsYear = d.jobs_month * 12;
    var hoursYear = saved * jobsYear;
    var valueYear = hoursYear * d.rate;
    var net1 = valueYear - d.scanner_cost - d.software_year;
    var net2 = valueYear - d.software_year;
    var paybackJobs = valueJob > 0 ? d.scanner_cost / valueJob : Infinity;
    var paybackMonths =
      valueJob > 0 && d.jobs_month > 0 ? paybackJobs / d.jobs_month : Infinity;
    var returnsAvoided =
      ((d.manual_return_pct - d.scan_return_pct) / 100) * jobsYear;
    var extraJobs = scanHours > 0 && saved > 0 ? hoursYear / scanHours : 0;
    var yearOneOk = saved > 0 && valueJob > 0 && net1 > 0;

    return {
      manHours: manHours,
      scanHours: scanHours,
      saved: saved,
      valueJob: valueJob,
      hoursYear: hoursYear,
      valueYear: valueYear,
      net1: net1,
      net2: net2,
      paybackJobs: paybackJobs,
      paybackMonths: paybackMonths,
      returnsAvoided: returnsAvoided,
      extraJobs: extraJobs,
      pays: yearOneOk
    };
  }

  function setText(root, key, text) {
    root.querySelectorAll('[data-pb-out="' + key + '"]').forEach(function (el) {
      el.textContent = text;
    });
  }

  function summaryText(d, r, presetLabel) {
    var lines = [
      'Manual measure vs handheld scan',
      presetLabel ? 'Starting figures: ' + presetLabel : '',
      '',
      'Your work',
      'As-built jobs per month: ' + d.jobs_month,
      'Charge-out rate: $' + d.rate + ' / hour',
      'Typical floor area per job: ' + d.area + ' m2',
      '',
      'How you do it now',
      'Hours on site, per person: ' + d.manual_site,
      'People on site: ' + d.manual_people,
      'Hours drafting up from the notes: ' + d.manual_draft,
      'Jobs needing a return visit: ' + d.manual_return_pct + '%',
      'Hours lost to each return visit: ' + d.manual_return_hours,
      'Hours per job (manual): ' + round(r.manHours, 1),
      '',
      'With a handheld scanner',
      'Hours on site, one person: ' + d.scan_site,
      'Hours processing and registering: ' + d.scan_process,
      'Hours modelling from the point cloud: ' + d.scan_model,
      'Jobs needing a return visit: ' + d.scan_return_pct + '%',
      'Hours per job (scan): ' + round(r.scanHours, 1),
      '',
      'The purchase',
      'Scanner: ' + (d.scanner_name || 'SHARE C1 Pro') + ' (' + money(d.scanner_cost) + ')',
      'Twelve months of MapShare Studio is included with each purchase.',
      '',
      'Result'
    ];
    if (r.pays) {
      lines.push(
        'Pays for itself in ' + jobsPhrase(r.paybackJobs),
        'About ' +
          round(r.paybackMonths, 1) +
          ' months at ' +
          d.jobs_month +
          ' ' +
          jobWord(d.jobs_month) +
          ' a month'
      );
    } else if (r.saved > 0 && r.valueJob > 0) {
      lines.push(
        'Does not pay back in year one',
        'Would take ' +
          jobsPhrase(r.paybackJobs) +
          ', about ' +
          round(r.paybackMonths, 1) +
          ' months at ' +
          d.jobs_month +
          ' ' +
          jobWord(d.jobs_month) +
          ' a month'
      );
    } else {
      lines.push('Does not pay back on these numbers');
    }
    lines.push(
      'Hours saved per job: ' + round(r.saved, 1),
      'Value of that time: ' + money(r.valueJob),
      'Hours saved per year: ' + round(r.hoursYear, 1),
      'Net benefit, year one: ' + money(r.net1),
      'Net benefit, year two on: ' + money(r.net2),
      'Return visits avoided per year: ' + round(r.returnsAvoided, 1),
      'Extra jobs the freed time buys: ' + round(r.extraJobs, 0) + ' / yr',
      '',
      'Time saved only becomes money if you fill it with billable work.',
      'These are your figures, not a Mirrormapper estimate of your business.'
    );
    return lines.filter(function (line, i, arr) {
      if (line === '' && arr[i - 1] === '') return false;
      return true;
    }).join('\n');
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
  }

  function printRow(label, value) {
    return (
      '<tr><th>' +
      esc(label) +
      '</th><td>' +
      esc(value) +
      '</td></tr>'
    );
  }

  function printBlock(title, rows) {
    return (
      '<h2>' +
      esc(title) +
      '</h2><table>' +
      rows.join('') +
      '</table>'
    );
  }

  function printSheetHtml(d, r, presetLabel) {
    var resultRows;
    if (r.pays) {
      resultRows = [
        printRow('Pays for itself in', jobsPhrase(r.paybackJobs)),
        printRow(
          'At this volume',
          round(r.paybackMonths, 1) +
            ' months at ' +
            d.jobs_month +
            ' ' +
            jobWord(d.jobs_month) +
            ' a month'
        )
      ];
    } else if (r.saved > 0 && r.valueJob > 0) {
      resultRows = [
        printRow('Result', 'Does not pay back in year one'),
        printRow(
          'Would take',
          jobsPhrase(r.paybackJobs) +
            ', about ' +
            round(r.paybackMonths, 1) +
            ' months'
        )
      ];
    } else {
      resultRows = [printRow('Result', 'Does not pay back on these numbers')];
    }
    resultRows = resultRows.concat([
      printRow('Hours saved per job', hoursLabel(r.saved)),
      printRow('Value of that time', money(r.valueJob)),
      printRow('Hours saved per year', hoursLabel(r.hoursYear)),
      printRow('Net benefit, year one', money(r.net1)),
      printRow('Net benefit, year two on', money(r.net2)),
      printRow(
        'Return visits avoided per year',
        String(round(r.returnsAvoided, 1))
      ),
      printRow(
        'Extra jobs the freed time buys',
        Math.max(0, Math.round(r.extraJobs)) + ' / yr'
      )
    ]);

    var today = new Date().toLocaleDateString('en-AU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });

    return (
      '<!DOCTYPE html><html lang="en-AU"><head><meta charset="utf-8">' +
      '<title>Payback summary</title>' +
      '<style>' +
      '@page { size: A4; margin: 14mm; }' +
      'html,body { margin: 0; padding: 0; background: #fff; color: #1b1d1d; }' +
      'body { font: 11pt/1.4 Arial, Helvetica, sans-serif; padding: 0; }' +
      '.sheet { max-width: 190mm; }' +
      '.brand { font-size: 10pt; font-weight: 700; letter-spacing: .04em; text-transform: uppercase; color: #8379ff; margin: 0 0 6px; }' +
      'h1 { font-size: 18pt; line-height: 1.15; margin: 0 0 4px; }' +
      '.meta { font-size: 9.5pt; color: #6b6f7d; margin: 0 0 16px; }' +
      'h2 { font-size: 9pt; font-weight: 700; letter-spacing: .06em; text-transform: uppercase; color: #6b6f7d; margin: 14px 0 4px; border-bottom: 1px solid #e4e5ec; padding-bottom: 3px; }' +
      'table { width: 100%; border-collapse: collapse; }' +
      'th, td { padding: 3px 0; font-size: 10.5pt; vertical-align: baseline; }' +
      'th { text-align: left; font-weight: 500; padding-right: 16px; }' +
      'td { text-align: right; font-weight: 700; white-space: nowrap; }' +
      '.note { font-size: 9pt; color: #6b6f7d; margin: 16px 0 0; }' +
      '</style></head><body><div class="sheet">' +
      '<p class="brand">Mirrormapper</p>' +
      '<h1>What the tape measure is costing you</h1>' +
      '<p class="meta">' +
      esc(presetLabel ? 'Starting figures: ' + presetLabel + '. ' : '') +
      esc(today) +
      '. Your figures, not a Mirrormapper estimate.</p>' +
      printBlock('Your work', [
        printRow('Jobs a month', String(d.jobs_month)),
        printRow('Charge-out rate', money(d.rate) + ' / hour'),
        printRow('Typical floor area', d.area + ' m2')
      ]) +
      printBlock('How you do it now', [
        printRow('Hours on site, per person', String(d.manual_site)),
        printRow('People on site', String(d.manual_people)),
        printRow('Hours drafting from the notes', String(d.manual_draft)),
        printRow('Jobs needing a return visit', d.manual_return_pct + '%'),
        printRow('Hours lost to each return', String(d.manual_return_hours)),
        printRow('Hours per job', hoursLabel(r.manHours))
      ]) +
      printBlock('With a handheld scanner', [
        printRow('Hours on site, one person', String(d.scan_site)),
        printRow('Hours processing and registering', String(d.scan_process)),
        printRow('Hours modelling from the cloud', String(d.scan_model)),
        printRow('Jobs needing a return visit', d.scan_return_pct + '%'),
        printRow('Hours per job', hoursLabel(r.scanHours))
      ]) +
      printBlock('The purchase', [
        printRow(
          'Scanner',
          (d.scanner_name || 'SHARE C1 Pro') + ' (' + money(d.scanner_cost) + ')'
        ),
        printRow(
          'Software',
          'Twelve months of MapShare Studio included with each purchase'
        )
      ]) +
      printBlock('Result', resultRows) +
      '<p class="note">Time saved only becomes money if you fill it with billable work. Modelling from the cloud is never counted as zero.</p>' +
      '</div></body></html>'
    );
  }

  function printHtml(html) {
    var frame = document.createElement('iframe');
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('title', 'Print summary');
    frame.style.cssText =
      'position:fixed;left:-10000px;top:0;width:800px;height:1100px;border:0;';
    document.body.appendChild(frame);
    var win = frame.contentWindow;
    var doc = win && (frame.contentDocument || win.document);
    if (!doc || !win) {
      if (frame.parentNode) frame.parentNode.removeChild(frame);
      return false;
    }
    doc.open();
    doc.write(html);
    doc.close();
    var cleaned = false;
    var cleanup = function () {
      if (cleaned) return;
      cleaned = true;
      if (frame.parentNode) frame.parentNode.removeChild(frame);
    };
    win.onafterprint = cleanup;
    window.setTimeout(function () {
      try {
        win.focus();
        win.print();
      } catch (e) {
        cleanup();
        return;
      }
      window.setTimeout(cleanup, 4000);
    }, 50);
    return true;
  }

  function paint(root, d, r) {
    var negative = !r.pays;
    root.classList.toggle('mm-pb--negative', negative);

    if (r.saved <= 0) {
      setText(root, 'headline', 'Does not pay back on these numbers');
      setText(
        root,
        'headline_sub',
        'On these hours the scanner does not free time. That is a real answer. Raise the job volume, or keep measuring the way you do now.'
      );
      setText(root, 'payback_jobs', 'n/a');
    } else if (!r.pays) {
      setText(root, 'headline', 'Does not pay back in year one');
      setText(
        root,
        'headline_sub',
        'On these numbers it takes ' +
          jobsPhrase(r.paybackJobs) +
          ', about ' +
          round(r.paybackMonths, 1) +
          ' months at ' +
          d.jobs_month +
          ' ' +
          jobWord(d.jobs_month) +
          ' a month. The kit still frees time. The cash takes longer.'
      );
      setText(root, 'payback_jobs', jobsPhrase(r.paybackJobs));
    } else {
      setText(root, 'headline', 'Pays for itself in');
      setText(
        root,
        'headline_sub',
        'About ' +
          round(r.paybackMonths, 1) +
          ' months at ' +
          d.jobs_month +
          ' ' +
          jobWord(d.jobs_month) +
          ' a month, then the time saved is yours.'
      );
      setText(root, 'payback_jobs', jobsPhrase(r.paybackJobs));
    }

    setText(root, 'saved_job', hoursLabel(r.saved));
    setText(root, 'value_job', money(r.valueJob));
    setText(root, 'hours_year', hoursLabel(r.hoursYear));
    setText(root, 'net1', money(r.net1));
    setText(root, 'net2', money(r.net2));
    setText(root, 'returns', round(r.returnsAvoided, 1).toLocaleString('en-AU', { maximumFractionDigits: 1 }));
    setText(root, 'extra', Math.max(0, Math.round(r.extraJobs)) + ' / yr');
    setText(root, 'man_hours', hoursLabel(r.manHours));
    setText(root, 'scan_hours', hoursLabel(r.scanHours));

    var bodyField = root.querySelector('[data-pb-summary-body]');
    if (bodyField) {
      var label = root.getAttribute('data-pb-preset-label') || '';
      bodyField.value = summaryText(d, r, label);
    }

    root.querySelectorAll('[data-pb-net]').forEach(function (el) {
      var key = el.getAttribute('data-pb-out');
      var val = key === 'net2' ? r.net2 : r.net1;
      el.classList.toggle('is-neg', val < 0);
      el.classList.toggle('is-ok', val > 0);
    });
  }

  function writeUrl(d) {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location.href);
      KEYS.forEach(function (k) {
        url.searchParams.set(URL_PREFIX + k, String(d[k]));
      });
      url.searchParams.set('pb_scanner', d.scanner || 'c1-pro');
      url.searchParams.delete('pb_scanner_cost');
      url.searchParams.delete('pb_software_year');
      url.searchParams.set('pb_v', '1');
      window.history.replaceState({}, '', url);
    } catch (e) {
      /* ignore */
    }
  }

  function applyUrl(root) {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.get('pb_v')) return;
      KEYS.forEach(function (k) {
        var raw = url.searchParams.get(URL_PREFIX + k);
        if (raw == null || raw === '') return;
        var el = root.querySelector('[data-pb="' + k + '"]');
        if (el) el.value = raw;
      });
      var sel = root.querySelector('[data-pb="scanner"]');
      if (sel) {
        var scannerRaw = url.searchParams.get('pb_scanner');
        if (scannerRaw === 'c1' || scannerRaw === 'c1-pro') {
          sel.value = scannerRaw;
        } else if (url.searchParams.get('pb_scanner_cost') === '6199') {
          sel.value = 'c1';
        }
      }
    } catch (e) {
      /* ignore */
    }
  }

  function toast(root, msg) {
    var el = root.querySelector('[data-pb-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
    window.setTimeout(function () {
      el.classList.remove('is-on');
    }, 2200);
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-pb-ready') === '1') return;
    root.setAttribute('data-pb-ready', '1');

    applyUrl(root);

    function run(syncUrl) {
      var d = readInputs(root);
      var r = compute(d);
      paint(root, d, r);
      if (syncUrl) writeUrl(d);
    }

    root.addEventListener('input', function (e) {
      if (!e.target || !e.target.hasAttribute('data-pb')) return;
      run(true);
    });
    root.addEventListener('change', function (e) {
      if (!e.target || !e.target.hasAttribute('data-pb')) return;
      run(true);
    });

    var resetBtn = root.querySelector('[data-pb-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        root.querySelectorAll('[data-pb]').forEach(function (el) {
          var def = el.getAttribute('data-default');
          if (def != null) el.value = def;
        });
        run(true);
        toast(root, 'Defaults restored');
      });
    }

    var copyBtn = root.querySelector('[data-pb-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var d = readInputs(root);
        var r = compute(d);
        var label = root.getAttribute('data-pb-preset-label') || '';
        var text = summaryText(d, r, label);
        var done = function () {
          toast(root, 'Summary copied');
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done).catch(function () {
            window.prompt('Copy this summary', text);
          });
        } else {
          window.prompt('Copy this summary', text);
        }
      });
    }

    var printBtn = root.querySelector('[data-pb-print]');
    if (printBtn) {
      printBtn.addEventListener('click', function () {
        var d = readInputs(root);
        var r = compute(d);
        var label = root.getAttribute('data-pb-preset-label') || '';
        var ok = printHtml(printSheetHtml(d, r, label));
        if (!ok) toast(root, 'Print window was blocked');
      });
    }

    var emailToggle = root.querySelector('[data-pb-email-toggle]');
    var emailPanel = root.querySelector('[data-pb-email-panel]');
    if (emailToggle && emailPanel) {
      emailToggle.addEventListener('click', function () {
        var open = emailPanel.hasAttribute('hidden');
        if (open) emailPanel.removeAttribute('hidden');
        else emailPanel.setAttribute('hidden', '');
        emailToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    var form = root.querySelector('form[data-pb-email-form]');
    if (form) {
      form.addEventListener('submit', function () {
        run(false);
      });
    }

    run(false);
  }

  function boot() {
    document.querySelectorAll('[data-mm-payback]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
